<template>
  <div id="glossary">
    <h2>長野県 県歌</h2>
    <h1>「信 濃 の 国」</h1>
    <h2>浅井洌 作詞</h2>

    <h2>一</h2>
    <span class="md-body-2">
信濃の国は十州に<br/>
境連ぬる国にして<br/>
聳ゆる山はいや高く<br/>
流るる川はいや遠し<br/>
松本伊那佐久善光寺<br/>
四つの平は肥沃の地<br/>
海こそなけれ物さわに<br/>
万ず足らわぬ事ぞなき
    </span>

    <h2>二</h2>
    <span class="md-body-2">
四方に聳ゆる山々は<br/>
御嶽乗鞍駒ヶ岳<br/>
浅間は殊に活火山<br/>
いずれも国の鎮めなり<br/>
流れ淀まずゆく水は<br/>
北に犀川千曲川<br/>
南に木曽川天竜川<br/>
これまた国の固めなり
    </span>

    <h2>三</h2>
    <span class="md-body-2">
木曽の谷には真木茂り<br/>
諏訪の湖には魚多し<br/>
民のかせぎも豊かにて<br/>
五穀の実らぬ里やある<br/>
しかのみならず桑とりて<br/>
蚕飼いの業の打ちひらけ<br/>
細きよすがも軽からぬ<br/>
国の命を繋ぐなり
    </span>

    <h2>四</h2>
    <span class="md-body-2">
尋ねまほしき園原や<br/>
旅のやどりの寝覚の床<br/>
木曽の棧かけし世も<br/>
心してゆけ久米路橋<br/>
くる人多き筑摩の湯<br/>
月の名にたつ姨捨山<br/>
しるき名所と風雅士が<br/>
詩歌に詠みてぞ伝えたる
    </span>

    <h2>五</h2>
    <span class="md-body-2">
旭将軍義仲も<br/>
仁科の五郎信盛も<br/>
春台太宰先生も<br/>
象山佐久間先生も<br/>
皆此国の人にして<br/>
文武の誉たぐいなく<br/>
山と聳えて世に仰ぎ<br/>
川と流れて名は尽ず
    </span>

    <h2>六</h2>
    <span class="md-body-2">
吾妻はやとし日本武<br/>
嘆き給いし碓氷山<br/>
穿つ隧道二十六<br/>
夢にも越る汽車の道<br/>
みち一筋に学びなば<br/>
昔の人にや劣るべき<br/>
古来山河の秀でたる<br/>
国は偉人のある習い<br/>
    </span>

    <br/>

    <span class="md-body-2">
    <a href="https://www.aozora.gr.jp/cards/000380/files/50555_37463.html" target="_blank">『県歌　信濃の国』 - 青空文庫</a>
    </span>

        <md-divider></md-divider>

    <span class="md-caption">copyright © 2017-{{ new Date().getFullYear() }} Hiroshi Jo</span>

  </div>
</template>

<script>
// import db from '../db'

export default {
  name: 'set',
  data () {
    return {
      error: null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

h2 {
  margin-top: 48px;
}

a {
  color: #42b983;
}

.md-body-2 {
  padding-left: 16px;
  padding-right: 16px;
}
.md-divider {
  margin: 32px 0 8px 0;
}
</style>



// WEBPACK FOOTER //
// Shinano.vue?757bb664